import { z } from "zod";

const selectionValidationErrors = [
	"AllowDistribution",
	"BatchAlreadyProducing",
	"BatchNotFound",
	"CannotProduceBatch",
	"FilterByItemsThatCanBeProducedOnTheCurrentMachineGroup",
	"FilterByLoadedMedia",
	"FilterByMachine",
	"FilterByMachineGroup",
	"FilterByOptimalProduction",
	"FilterByPackStation",
	"FilterByStoppedCartonPropertyGroup",
	"FilterByStoppedClassification",
	"FilterByStoppedPickZone",
	"FilterOutCannotProduceSingle",
	"UnableToCalculate",
] as const;

export const selectionValidationErrorSchema = z.enum(selectionValidationErrors);
